import { customerKeys } from './keys';
import { queryClient } from './queryClient';

// Freshness bound only: answers are normally dropped earlier, when the data they depend on changes.
const CUSTOMER_DATA_STALE_MS = 2 * 60 * 1000;

// Callers with the same key share the in-flight request and its answer until it is invalidated.
export const fetchCustomerData = async (queryKey, request) => {
    // The request helper answers undefined on a network failure, which the query client does not accept as data.
    const { res } = await queryClient.fetchQuery({
        queryKey,
        queryFn: async () => ({ res: await request() }),
        staleTime: CUSTOMER_DATA_STALE_MS,
        gcTime: CUSTOMER_DATA_STALE_MS,
        retry: false,
    });
    // "Not found" (ack false) is a real answer worth reusing; only a missing or failed response is dropped.
    if (!res || res.success === false) queryClient.removeQueries({ queryKey, exact: true });
    return res;
};

// Suggested products leave out what the customer has ordered, so order items changing makes them stale.
export const forgetSuggestedProducts = () =>
    queryClient.invalidateQueries({ queryKey: customerKeys.suggestedAll(), refetchType: 'none' });

// Puts an answer that arrived with another response where the next call for it will find it.
export const seedCustomerData = (queryKey, res) => queryClient.setQueryData(queryKey, { res });

// The name shown in the customer field, from a profile that already arrived, so it is not looked up again.
export const seedCustomerOption = (profile) => {
    const id = Number(profile?.customer_netsuite_id);
    if (!id || !profile?.code || !profile?.title) return;
    queryClient.setQueryData(customerKeys.option(id), { customer_netsuite_id: id, code: profile.code, title: profile.title });
};
